import { createRequest, platform } from "@shared/platform-api/requests"
import { createRequestHook } from "../createRequestHook"

import { PolicyTspsInput, TspList } from "./types"

export type PolicyAssociationsInput = Readonly<{ id: string; tspIds: Array<string> }>

export const findPolicyTsps = createRequest<PolicyTspsInput, TspList>(async (input, getToken) =>
  platform(getToken).policies.findPolicyAssociations(input)
)

export const useFindPolicyTsps = createRequestHook(findPolicyTsps)

export const addPolicyAssociations = createRequest<PolicyAssociationsInput, { message?: string | undefined }>(
  async ({ id, tspIds }, getToken) =>
    platform(getToken).policies.savePolicyAssociations({ id, requestBody: { tspIds } })
)

export const useAddPolicyAssociations = createRequestHook(addPolicyAssociations)
